import {computed, observable} from "mobx";
import {StringHelpers} from "shared/StringHelpers";

export class FeedItemEntity {
  @observable completed = false;
  @observable pointsAwarded = 0;
  @observable pointsAwardedDate: Date|null = null;
  @observable read = false;
  @observable data:any|null = null;
  @observable step = 0;
  @observable _post:any|null = null;
  @observable unlockedDate;

  // @computed get needsUnlocking() {
  //   return this._post; // && this._post.lockedWithCodeword; // && !this.unlockedDate;
  // }

  // @observable needsUnlocking = true;

  displayDate: Date;
  readDate: Date; //"2021-03-12T17:30:06.588Z"
  postType: string;
  tags:any; // array
  type: string
  userId:string;
  _id:string;
  _postAuthor:any;
  solutionId:string;
  bundleId:string;
  content: string; // only non-post feed items (such as check-in)
  icon: string; // only non-post feed items (such as check-in)

  constructor(json:any) {
    this.completed = json.completed;
    this.pointsAwarded = json.pointsAwarded ? json.pointsAwarded : 0;
    this.pointsAwardedDate = json.pointsAwardedDate;
    this.read = json.read;
    this.displayDate = json.displayDate;
    this.readDate = json.readDate;
    this.postType = json.postType;
    this.step = json.step;
    this.tags = json.tags;
    this.type = json.type;
    this.userId = json.userId;
    this._id = json._id;
    this._post = json._post;
    this._postAuthor = json._postAuthor;
    this.data = json.data ? json.data : null;
    this.solutionId = json.solutionId;
    this.bundleId = json.bundleId;
    this.content = json.content;
    this.icon = json.icon;
    this.unlockedDate = json.unlockedDate;
  }
}

export const feedItemHasFullPost = function(feedItem:FeedItemEntity) {
    if(feedItem._post){
      const fullPost = StringHelpers.safeHTML(feedItem._post.fullPost);
      if(null!==fullPost) {
        return true;
      }
    }
    return false
  }


export const initializeFeedItemEntities = function(jsonSrcArray:any){
  const entities:FeedItemEntity[] = [];
  jsonSrcArray.forEach(json=>{
      entities.push(new FeedItemEntity(json));
    }
  )
  return entities;
}
